import { ContractType, NoteStateTypes } from 'app/models/common-types'
import { NoteState } from './reducer'

export const getNotes = (state: { notes: NoteState }) => state.notes

export const getNotesForType =
  (type: ContractType) => (state: { notes: NoteState }) => {
    const noteStateType = NoteStateTypes[type]
    return state.notes[noteStateType]
  }
